import { useContext, useState } from "react";
import { AppContext } from "../Context";

function ParamPocket() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const pockets = [{ id: "noPocket", caption: "No Pocket", img: "noPocket.svg", active: true }, { id: "Pocket1", caption: "1 Pocket", img: "Pocket1.svg", active: false }, { id: "Pocket2", caption: "2 Pockets", img: "Pocket2.svg", active: false }];

    function onItemClick(id) {
        dispatch({ type: "SET_POCKET", payload: id })
        if (id == "Pocket1" || id == "Pocket2") {
            dispatch({ type: "SET_POCKET_PRICE", payload: 5 });
        } else {
            dispatch({ type: "SET_POCKET_PRICE", payload: 0 });
        }
        dispatch({ type: "SET_DONE", payload: true });
    }

    return (
        <div className="paramItem">
            <div className="paramHeader">
                <div className="paramTitle">Pocket</div>
                <div className="paramPrice">+$5</div>
            </div>
            <div className="monoList">
                {pockets.map((pocket, index) => (
                    <div key={index} className="subMenuType" onClick={() => { onItemClick(pocket.id) }}>
                        <img className="fabricImg" src={`${process.env.PUBLIC_URL}/images/${pocket.img}`} />
                        <div className="subMenuLabel">{pocket.caption}</div>
                        {state.pocket === pocket.id && (
                            <img
                                className="tick"
                                src={process.env.PUBLIC_URL + "/images/tick.svg"}
                                width={20}
                                alt="selected"
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}
export default ParamPocket